import { Theme } from "@tdp/common/theme";

export enum TrendColor {
  Success = "#0E700E",
  Failure = "#B10E1C"
}

export enum Alignment {
  Left = "left",
  Right = "right",
  Center = "center"
}

export const multiLineWidth = 2.5;

export const containerStyle = {
  style: { height: "100%", width: "100%" }
};

export interface IHighChartChartTheme {
  color: string;
  lineColors: string[];
  backgroundColor: string;
  tooltip: {
    backgroundColor: string;
    style: {
      color: string;
    };
  };
  legend: string;
}

const defaultTheme: IHighChartChartTheme = {
  color: "#616161",
  lineColors: ["#5B5FC7", "#383966", "#C5CBFA", "#BDBDBD"],
  backgroundColor: "#FFFFFF",
  tooltip: {
    backgroundColor: "#3e3e3e",
    style: {
      color: "#FFFFFF"
    }
  },
  legend: "#000000"
};

const darkTheme: IHighChartChartTheme = {
  color: "#8b8b8b",
  lineColors: ["#5B5FC7", "#383966", "#C5CBFA", "#BDBDBD"],
  backgroundColor: "#292929",
  tooltip: {
    backgroundColor: "#FFFFFF",
    style: {
      color: "#000000"
    }
  },
  legend: "#FFFFFF"
};

const highContrastTheme: IHighChartChartTheme = {
  color: "#FFFFFF",
  lineColors: ["#1AEBFF", "#FFFFFF", "#FFFF00", "#FF66FF"],
  backgroundColor: "#000000",
  tooltip: {
    backgroundColor: "#FFFFFF",
    style: {
      color: "#000000"
    }
  },
  legend: "#FFFFFF"
};

export const getStyles = (theme: Theme): IHighChartChartTheme => {
  switch (theme) {
    case 'light':
      return defaultTheme;
    case 'dark':
      return darkTheme;
    case 'contrast':
      return highContrastTheme;
    default:
      return defaultTheme;
  }
};
